module.exports = {
  '46ca8471-1831-4748-82f0-78fe4ea22841': {
    'active': true,
    'addToCartType': 'DIRECT_URL',
    'cartColor': '#f09b3a',
    'cartLogo': [
      'https://attach-videos.s3.amazonaws.com/cartLogo-amazon.png',
    ],
    'cartName': 'Amazon',
    'cartPlatform': 'amazon',
    'cartSlug': 'amazon',
    'currencyType': 'usd',
    'id': '46ca8471-1831-4748-82f0-78fe4ea22841',
    'productPageHostName': 'amazon.com',
    'squareCartLogo': [
      'https://attach-videos.s3.amazonaws.com/ZsXyM7U5S7CiIPyr0V9C_amazon-multicart-logo.png',
    ],
  },
  'd6e13c1d-0ac9-4b2a-aea8-b8f8e0d91e43': {
    'active': true,
    'addToCartType': 'DIRECT_URL',
    'cartColor': '#347ebf',
    'cartLogo': [
      'https://attach-videos.s3.amazonaws.com/cartLogo-walmart.png',
    ],
    'cartName': 'Walmart',
    'cartPlatform': 'walmart',
    'cartSlug': 'walmart',
    'currencyType': 'usd',
    'id': 'd6e13c1d-0ac9-4b2a-aea8-b8f8e0d91e43',
    'productPageHostName': 'walmart.com',
    'squareCartLogo': [
      'https://attach-videos.s3.amazonaws.com/A3WX28npTbaQCTdXTNIN_walmart-multicart-logo.png',
    ],
  },
  '3d1b8236-68c0-4e1d-818e-eb0d073fd7b9': {
    'active': true,
    'addToCartType': 'DIRECT_URL',
    'cartColor': '#b8241a',
    'cartLogo': [
      'https://attach-videos.s3.amazonaws.com/cartLogo-target.png',
    ],
    'cartName': 'Target',
    'cartPlatform': 'target',
    'cartSlug': 'target',
    'currencyType': 'usd',
    'id': '3d1b8236-68c0-4e1d-818e-eb0d073fd7b9',
    'productPageHostName': 'target.com',
    'squareCartLogo': [
      'https://attach-videos.s3.amazonaws.com/5u9gnQM5SOCdX6JCCyWu_target-multicart-logo.png',
    ],
  },
  '7c3b28d3-2d4f-33c7-ff9e-2e7becbae97b': {
    'active': true,
    'addToCartType': 'DIRECT_URL',
    'cartColor': '#eb5d5e',
    'cartLogo': [
      'https://attach-videos.s3.amazonaws.com/cartLogo-qvc.png',
    ],
    'cartName': 'QVC',
    'cartPlatform': 'qvc',
    'cartSlug': 'qvc',
    'currencyType': 'usd',
    'id': '7c3b28d3-2d4f-33c7-ff9e-2e7becbae97b',
    'productPageHostName': 'qvc.com',
    'squareCartLogo': [
      'https://attach-videos.s3.amazonaws.com/NuHLSFGxQMGMNuF3TRRE_QVCcustom.png',
    ],
  },
};
